import { PaginationType } from "helpers";

export const Pagination = ({
  totalRows,
  currentPage,
  pageSize,
  previousClick,
  nextClick,
}: Props) => {
  const calculatedTo = calculateTo(currentPage, pageSize, totalRows);
  const calculatedFrom = calculateFrom(
    currentPage,
    pageSize,
    totalRows,
    calculatedTo
  );

  if (!totalRows) return null;
  return (
    <nav
      className="bg-white flex items-center justify-between"
      aria-label="Pagination"
    >
      <div className="hidden sm:block">
        <p className="text-sm text-gray-700">
          Showing <span className="font-medium">{calculatedFrom}</span> to{" "}
          <span className="font-medium">{calculatedTo}</span> of{" "}
          <span className="font-medium">{totalRows}</span> results
        </p>
      </div>
      <div className="flex-1 flex justify-between sm:justify-end">
        <button
          onClick={previousClick}
          className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          disabled={calculatedFrom === 1}
        >
          Previous
        </button>
        <button
          onClick={nextClick}
          disabled={calculatedTo === totalRows}
          className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Next
        </button>
      </div>
    </nav>
  );
};

interface Props extends PaginationType {
  previousClick?: () => void;
  nextClick?: () => void;
}

const calculateTo = (
  currentPage: number,
  pageSize: number,
  totalRows: number
) => {
  if (currentPage === 1) return pageSize;

  const newTo = currentPage * pageSize;
  if (newTo > totalRows) return totalRows;
  return newTo;
};

const calculateFrom = (
  currentPage: number,
  pageSize: number,
  totalRows: number,
  calculatedTo: number
) => {
  if (calculatedTo === totalRows) {
    return currentPage * pageSize - (pageSize - 1);
  }

  return calculatedTo - (pageSize - 1);
};
